export const AUTO_LAYOUT_CHANGE_DATA = 'auto_layout/AUTO_LAYOUT_CHANGE_DATA';
export const AUTO_LAYOUT_CHANGE_SCREEN_PROPERTY =
  'auto_layout/AUTO_LAYOUT_CHANGE_SCREEN_PROPERTY';
export const AUTO_LAYOUT_DELETE_DATA = 'auto_layout/AUTO_LAYOUT_DELETE_DATA';
export const AUTO_LAYOUT_DELETE_DATA_FAILURE =
  'auto_layout/AUTO_LAYOUT_DELETE_DATA_FAILURE';
export const AUTO_LAYOUT_DELETE_DATA_SUCCESS =
  'auto_layout/AUTO_LAYOUT_DELETE_DATA_SUCCESS';
export const AUTO_LAYOUT_DATA_REMOVED = 'auto_layout/AUTO_LAYOUT_DATA_REMOVED';
export const AUTO_LAYOUT_FETCH_DATA = 'auto_layout/AUTO_LAYOUT_FETCH_DATA';
export const AUTO_LAYOUT_FETCH_DATA_FAILURE =
  'auto_layout/AUTO_LAYOUT_FETCH_DATA_FAILURE';
export const AUTO_LAYOUT_FETCH_DATA_SUCCESS =
  'auto_layout/AUTO_LAYOUT_FETCH_DATA_SUCCESS';
export const AUTO_LAYOUT_FETCH_METADATA_FAILURE =
  'auto_layout/AUTO_LAYOUT_FETCH_METADATA_FAILURE';
export const AUTO_LAYOUT_FETCH_METADATA_SUCCESS =
  'auto_layout/AUTO_LAYOUT_FETCH_METADATA_SUCCESS';
export const AUTO_LAYOUT_INDEX_ADD = 'auto_layout/AUTO_LAYOUT_INDEX_ADD';
export const AUTO_LAYOUT_INDEX_REMOVE = 'auto_layout/AUTO_LAYOUT_INDEX_REMOVE';
export const AUTO_LAYOUT_INIT_DATA = 'auto_layout/AUTO_LAYOUT_INIT_DATA';
export const AUTO_LAYOUT_INIT_SCREEN_PROPERTIES =
  'auto_layout/AUTO_LAYOUT_INIT_SCREEN_PROPERTIES';
export const AUTO_LAYOUT_CHECKED_INDEX_STATE =
  'auto_layout/AUTO_LAYOUT_CHECKED_INDEX_STATE';
export const AUTO_LAYOUT_CHECKED_INDEX_STATE_RESET =
  'auto_layout/AUTO_LAYOUT_CHECKED_INDEX_STATE_RESET';
export const AUTO_LAYOUT_CONFLICT_LAST_CHANGE_AUTHOR =
  'auto_layout/AUTO_LAYOUT_CONFLICT_LAST_CHANGE_AUTHOR';
export const AUTO_LAYOUT_CONFLICT_LAST_CHANGE_AUTHOR_RESET =
  'auto_layout/AUTO_LAYOUT_CONFLICT_LAST_CHANGE_AUTHOR_RESET';
export const AUTO_LAYOUT_RESET_CHANGES =
  'auto_layout/AUTO_LAYOUT_RESET_CHANGES';
export const AUTO_LAYOUT_SAVE_DATA = 'auto_layout/AUTO_LAYOUT_SAVE_DATA';
export const AUTO_LAYOUT_DATA_VALIDATED =
  'auto_layout/AUTO_LAYOUT_DATA_VALIDATED';
export const AUTO_LAYOUT_SAVE_DATA_FAILURE =
  'auto_layout/AUTO_LAYOUT_SAVE_DATA_FAILURE';
export const AUTO_LAYOUT_SAVE_DATA_SUCCESS =
  'auto_layout/AUTO_LAYOUT_SAVE_DATA_SUCCESS';
export const AUTO_LAYOUT_SET_METADATA = 'auto_layout/AUTO_LAYOUT_SET_METADATA';
export const AUTO_LAYOUT_LOAD_START = 'auto_layout/AUTO_LAYOUT_LOAD_START';
export const AUTO_LAYOUT_LOAD_END = 'auto_layout/AUTO_LAYOUT_LOAD_END';
export const CHANGE_SELECTED_SCREEN_ID =
  'auto_layout/CHANGE_SELECTED_SCREEN_ID';
export const SET_CURRENT_CONTEXT_PARAMS =
  'auto_layout/SET_CURRENT_CONTEXT_PARAMS';
export const SET_MINI_SCREENS_CONFIG = 'auto_layout/SET_MINI_SCREENS_CONFIG';
